// extracted by mini-css-extract-plugin
module.exports = {"title":"ReadCommentaire_title__2InkH","text":"ReadCommentaire_text__2MhB0"};